import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestData } from 'src/app/common/models/request-data.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItemClassDisplayOrderService {

  constructor(private http: HttpClient) { }

  getMenuDepartmentList(requestData:RequestData): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.post(environment.baseUrl+'/menu/get', requestData);
  }
  getItemClassDisplayOrderByMenuId(menuId: number): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.get(environment.baseUrl + '/item-class-display-order/get/' + menuId);
  }
  /**
     * 
     * @param reasonsInfo 
     * Calls the update API to insert/update the record
     */
     update(itemClassInfo:any): Observable<any> { 
        return this.http.post(environment.baseUrl+'/item-class-display-order/update', itemClassInfo);

    }
}
